import "core-js/modules/es6.regexp.replace";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "use-instruction-container"
  }, [!_vm.isMultipleDetails || _vm.couponDetail.instruction || !_vm.isReviewing && _vm.promoterGroup.openStatus == 1 && _vm.promoterGroup.qrcodeUrl ? [_vm.isTicket && _vm.couponDetail.voucherTicketNewEditMark ? [_vm.couponDetail.useInstruction || _vm.couponDetail.scenicExtInfo ? _c('div', {
    staticClass: "use-instruction-wrap"
  }, [_c('div', {
    staticClass: "row-text"
  }, [_c('div', {
    staticClass: "txt-title"
  }, [_vm._v("使用说明")]), _c('div', {
    ref: "useInstruction",
    staticClass: "cel-2 use-instruction",
    class: {
      collapse: !_vm.showMore
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.couponDetail.useInstruction.replace(/(\n|\r|\t)/g, '<br>'))
    }
  }), _vm.couponDetail.scenicExtInfo ? [_c('span', {
    staticClass: "no-border"
  }, [_vm._v("基础服务")]), _vm.couponDetail.scenicExtInfo.bussinessHours ? _c('p', [_vm._v("\n                营业时间：" + _vm._s(_vm.couponDetail.scenicExtInfo.bussinessHours) + "\n              ")]) : _vm._e(), _vm.couponDetail.scenicExtInfo.wifi ? _c('p', [_vm._v("\n                wifi：" + _vm._s(_vm.couponDetail.scenicExtInfo.wifi) + "\n              ")]) : _vm._e(), _vm.couponDetail.scenicExtInfo.parkingArea ? _c('p', [_vm._v("\n                停车位：" + _vm._s(_vm.couponDetail.scenicExtInfo.parkingArea) + "\n              ")]) : _vm._e()] : _vm._e()], 2)]), !_vm.showMore ? _c('div', {
    staticClass: "btn-expand-all"
  }, [_c('span', {
    staticClass: "btn-expand-txt",
    on: {
      "click": function click($event) {
        return _vm.expandAll();
      }
    }
  }, [_vm._v("查看全部")]), _c('ycf-image', {
    staticClass: "arrow-down",
    attrs: {
      "src": "/srcv2/images/arrow-down@2x.png"
    }
  })], 1) : _vm._e()]) : _vm._e()] : _vm.isEntranceTicket ? [_vm.couponDetail.useInstruction && typeof _vm.couponDetail.useInstruction == 'string' && ~~_vm.couponDetail.isShowTicketFields == 1 ? _c('div', {
    staticClass: "use-instruction-wrap"
  }, [_c('div', {
    staticClass: "row-text"
  }, [_c('div', {
    staticClass: "txt-title"
  }, [_vm._v("使用说明")]), _c('div', {
    ref: "useInstruction",
    staticClass: "cel-2 use-instruction",
    class: {
      collapse: !_vm.showMore
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.couponDetail.useInstruction.replace(/(\n|\r|\t)/g, '<br>'))
    }
  }), _vm.couponDetail.scenicExtInfo ? [_c('span', {
    staticClass: "no-border"
  }, [_vm._v("基础服务")]), _vm.couponDetail.scenicExtInfo.bussinessHours ? _c('p', [_vm._v("\n                营业时间：" + _vm._s(_vm.couponDetail.scenicExtInfo.bussinessHours) + "\n              ")]) : _vm._e(), _vm.couponDetail.scenicExtInfo.wifi ? _c('p', [_vm._v("\n                wifi：" + _vm._s(_vm.couponDetail.scenicExtInfo.wifi) + "\n              ")]) : _vm._e(), _vm.couponDetail.scenicExtInfo.parkingArea ? _c('p', [_vm._v("\n                停车位：" + _vm._s(_vm.couponDetail.scenicExtInfo.parkingArea) + "\n              ")]) : _vm._e()] : _vm._e()], 2)]), !_vm.showMore ? _c('div', {
    staticClass: "btn-expand-all"
  }, [_c('span', {
    staticClass: "btn-expand-txt",
    on: {
      "click": function click($event) {
        return _vm.expandAll();
      }
    }
  }, [_vm._v("查看全部")]), _c('ycf-image', {
    staticClass: "arrow-down",
    attrs: {
      "src": "/srcv2/images/arrow-down@2x.png"
    }
  })], 1) : _vm._e()]) : _vm._e()] : [~~_vm.couponDetail.isShowTicketFields == 1 && _vm.couponDetail.useInstruction ? _c('div', {
    staticClass: "use-instruction-wrap"
  }, [_c('div', {
    staticClass: "row-text"
  }, [_c('div', {
    staticClass: "txt-title"
  }, [_vm._v("使用说明")]), _c('div', {
    ref: "useInstruction",
    staticClass: "cel-2 use-instruction",
    class: {
      collapse: !_vm.showMore
    }
  }, [_vm.couponDetail.useInstruction ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.couponDetail.useInstruction.replace(/(\n|\r|\t)/g, '<br>'))
    }
  }) : _vm._e(), _vm.couponDetail.scenicExtInfo ? [_c('span', {
    staticClass: "no-border"
  }, [_vm._v("基础服务")]), _vm.couponDetail.scenicExtInfo.bussinessHours ? _c('p', [_vm._v("\n                营业时间：" + _vm._s(_vm.couponDetail.scenicExtInfo.bussinessHours) + "\n              ")]) : _vm._e(), _vm.couponDetail.scenicExtInfo.wifi ? _c('p', [_vm._v("\n                wifi：" + _vm._s(_vm.couponDetail.scenicExtInfo.wifi) + "\n              ")]) : _vm._e(), _vm.couponDetail.scenicExtInfo.parkingArea ? _c('p', [_vm._v("\n                停车位：" + _vm._s(_vm.couponDetail.scenicExtInfo.parkingArea) + "\n              ")]) : _vm._e()] : _vm._e()], 2)]), !_vm.showMore ? _c('div', {
    staticClass: "btn-expand-all"
  }, [_c('span', {
    staticClass: "btn-expand-txt",
    on: {
      "click": function click($event) {
        return _vm.expandAll();
      }
    }
  }, [_vm._v("查看全部")]), _c('ycf-image', {
    staticClass: "arrow-down",
    attrs: {
      "src": "/srcv2/images/arrow-down@2x.png"
    }
  })], 1) : _vm._e()]) : _vm._e()]] : _vm._e()], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };